export default function VersionEnvironment() {
  return (
    <>
      v.{process.env.REACT_APP_VERSION_NUMBER}.{process.env.REACT_APP_BUILD_NUMBER} {process.env.REACT_APP_ENV}
    </>
  );
}
